import { render, staticRenderFns } from "./ChannelDialog.vue?vue&type=template&id=b7fbf872&scoped=true"
import script from "./ChannelDialog.vue?vue&type=script&lang=js"
export * from "./ChannelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fbf872",
  null
  
)

export default component.exports